import { App as AntApp, Button, Form, Input } from "antd";
import axios from "axios";
import { useOutletContext } from "react-router";
import { ProductSectionCard } from "@/components";
import type { PortalWorkspaceContext } from "../components/PortalWorkspaceLayout";
import { PortalPageHeader, PortalPageShell } from "../components/PortalProduct";
import { portalRequest } from "../lib/auth";

/** Lets an authenticated agency user view identity details and change their password. */
const PortalProfilePage = () => {
  const { actor } = useOutletContext<PortalWorkspaceContext>();
  const { message } = AntApp.useApp();
  return (
    <PortalPageShell width="max-w-5xl">
      <div className="space-y-3">
        <PortalPageHeader
          title="Profile & security"
          meta="Account"
          description="Manage your agency portal identity and sign-in security."
        />
        <ProductSectionCard title="Account details">
          <dl className="grid gap-4 sm:grid-cols-2">
            <div>
              <dt className="text-xs text-gray-500">Name</dt>
              <dd className="mt-1 font-medium">{actor.fullname}</dd>
            </div>
            <div>
              <dt className="text-xs text-gray-500">Email</dt>
              <dd className="mt-1 font-medium">{actor.email}</dd>
            </div>
            <div>
              <dt className="text-xs text-gray-500">Agency</dt>
              <dd className="mt-1 font-medium">{actor.agency?.name}</dd>
            </div>
          </dl>
        </ProductSectionCard>
        <ProductSectionCard
          title="Change password"
          description="Changing your password signs out your other portal sessions."
        >
          <Form
            layout="vertical"
            requiredMark="optional"
            onFinish={async ({ currentPassword, newPassword, confirmPassword }) => {
              if (newPassword !== confirmPassword) {
                message.error("Passwords do not match");
                return;
              }
              try {
                await portalRequest({
                  url: "/api/agent-portal/auth/change-password",
                  method: "post",
                  data: { currentPassword, newPassword },
                });
                message.success("Password updated. Other portal sessions have been signed out.");
              } catch (error: unknown) {
                message.error(
                  axios.isAxiosError<{ error?: string }>(error)
                    ? error.response?.data?.error || "Unable to update password"
                    : "Unable to update password",
                );
              }
            }}
          >
            <Form.Item name="currentPassword" label="Current password" rules={[{ required: true }]}>
              <Input.Password autoComplete="current-password" />
            </Form.Item>
            <Form.Item name="newPassword" label="New password" rules={[{ required: true, min: 8 }]}>
              <Input.Password autoComplete="new-password" />
            </Form.Item>
            <Form.Item name="confirmPassword" label="Confirm new password" rules={[{ required: true }]}>
              <Input.Password autoComplete="new-password" />
            </Form.Item>
            <Button type="primary" htmlType="submit">
              Update password
            </Button>
          </Form>
        </ProductSectionCard>
      </div>
    </PortalPageShell>
  );
};
export default PortalProfilePage;
